import { render } from "./InstallNotification.vue?vue&type=template&id=14818b2b&scoped=true"
import script from "./InstallNotification.vue?vue&type=script&lang=js"
export * from "./InstallNotification.vue?vue&type=script&lang=js"

import "./InstallNotification.vue?vue&type=style&index=0&id=14818b2b&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14818b2b"]])

export default __exports__